import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeNotification from '@s-ui/react-molecule-notification'

import {NOTIFICATION_CLASS, NOTIFICATION_TYPES, NOTIFICATIONS_PROPS} from './config.js'

const NetChatNotification = ({type, onClose, onOpenDrawer}) => {
  const {i18n} = useContext(Context)

  const NOTIFICATIONS_LITERALS = {
    [NOTIFICATION_TYPES.GENERIC_ERROR]: i18n.t('NOTIFICATIONS.NETWORK_ERROR'),
    [NOTIFICATION_TYPES.FEEDBACK_SUCCESS]: i18n.t('NET.FEEDBACK.NOTIFICATION_SUCCESS'),
    [NOTIFICATION_TYPES.NEW_CHAT_SUCCESS]: i18n.t('NET.NEW_CHAT.NOTIFICATION_SUCCESS'),
    [NOTIFICATION_TYPES.CHAT_RESULTS_AVAILABLE]: i18n.t('NET.CHAT_RESULTS_AVAILABLE')
  }

  const buttons = [
    {
      negative: true,
      design: atomButtonDesigns.LINK,
      children: i18n.t('COMMON.SHOW'),
      onClick: onOpenDrawer
    }
  ]
  const buttonsProps = type === NOTIFICATION_TYPES.CHAT_RESULTS_AVAILABLE ? {buttons} : {}

  const baseClass = cx(NOTIFICATION_CLASS, {
    [`${NOTIFICATION_CLASS}--small`]: type === NOTIFICATION_TYPES.CHAT_RESULTS_AVAILABLE
  })

  if (!type) {
    return null
  }

  return (
    <div className={baseClass}>
      <MoleculeNotification {...NOTIFICATIONS_PROPS[type]} {...buttonsProps} onClose={onClose}>
        {NOTIFICATIONS_LITERALS[type]}
      </MoleculeNotification>
    </div>
  )
}

NetChatNotification.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)),
  onOpenDrawer: PropTypes.func
}

export {NOTIFICATION_TYPES as netChatNotificationsType}

export default NetChatNotification
